export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const mediaUrl = (value) => (value && value.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${value}` : value);

// youtu.be/ID, /watch?v=ID, /shorts/ID, /embed/ID — extra query params are ignored
export const youtubeId = (value) => {
  if (!value) return "";
  const match = String(value).match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return match ? match[1] : "";
};

export const youtubeThumb = (id) => `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
export const youtubeThumbFallback = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
export const youtubeEmbed = (id) => `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
